import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";

import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ImmortalFruitsGameConfig} from "../../ImmortalFruitsGameConfig";
import {ImmortalFruitsGameModuleConfig} from "../../ImmortalFruitsGameModuleConfig";

export class ImmortalFruitsSpinReelPartAnimator extends SpinReelPartAnimator {

    /**
     * @inheritDoc
     * @override To set the gold land state in free spin mode.
     */
   protected fadeOutSymbolBlur(): void {

       let state: ISymbolStateConfig = ImmortalFruitsGameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE ? ImmortalFruitsGameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE() : ImmortalFruitsGameConfig.instance.SYMBOL_STATES.normal;
        // && i>1 && i<6
        for (var i = 0; i < this._symbolsToAnimate.length; i++) {
            if((this.symbolsToAnimate[i].symName==="S"||this.symbolsToAnimate[i].symName==="W" )){
                state = ImmortalFruitsGameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE();
            }else{
                state = ImmortalFruitsGameConfig.instance.SYMBOL_STATES.normal;
            }
            this._symbolsToAnimate[i].changeState({
                state: state,
                replay: false,
                fadeInDuration: ImmortalFruitsGameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION,
                fadeInDelay: ImmortalFruitsGameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY
            });
        }
        //if(this._reelId==4){
            ImmortalFruitsGameModuleConfig.nearWinView.stopAllAnimations();
            //ImmortalFruitsGameModuleConfig.nearWinView.fadeOutAnimation();
        //}

    }
}